// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html,\nbody,\nh3,\np {\n  margin: 0;\n  padding: 0;\n}\n", "",{"version":3,"sources":["webpack://./src/App.vue"],"names":[],"mappings":"AACA;;;;EAIE,SAAA;EACA,UAAA;AAAF","sourcesContent":["\nhtml,\nbody,\nh3,\np {\n  margin: 0;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
